export default function getPatientFullAge(age?: any) {
  if (!age) {
    return '';
  }
  return [
    age.year,
    'Yrs.',
    age.month,
    'M',
    age.day,
    'D',
  ].join(' ');
}
